import { useTranslations } from "use-intl";

import { Button } from "@/components/ui/button";
import { useAdvertisingConsent } from "@/hooks/use-advertising-consent";

export function AdvertisingConsentSettings() {
  const t = useTranslations("globals.advertisingConsent");
  const { choice, choose } = useAdvertisingConsent();
  const displayedChoice = choice ?? "unset";

  return (
    <section
      className="not-prose my-6 rounded-xl border border-border/80 bg-card p-5 shadow-lg"
      aria-labelledby="ad-settings-title"
    >
      <h3 id="ad-settings-title" className="text-base font-bold text-foreground">
        {t("settingsTitle")}
      </h3>
      <p className="mt-1 text-sm leading-relaxed text-muted-foreground">
        {t("settingsDescription")}
      </p>
      <p className="mt-3 text-sm font-medium text-foreground" aria-live="polite">
        {t("status", { choice: displayedChoice })}
      </p>
      <div className="mt-4 flex flex-col gap-2 sm:flex-row">
        <Button
          aria-pressed={choice === "denied"}
          size="lg"
          variant={choice === "denied" ? "default" : "outline"}
          onClick={() => choose("denied")}
        >
          {t("necessaryOnly")}
        </Button>
        <Button
          aria-pressed={choice === "granted"}
          className="font-bold"
          size="lg"
          variant={choice === "granted" ? "default" : "outline"}
          onClick={() => choose("granted")}
        >
          {t("allowAdvertising")}
        </Button>
      </div>
    </section>
  );
}
